export const PATIENT = 'Patient';
export const OBSERVATION = 'Observation';
